export const baseUrl = "https://api.wowmixtr.com/api/landing/";
export const imageUrl = "https://api.wowmixtr.com";